import { Injectable, inject } from '@angular/core';
import { RestApiService } from '@core/services/rest-api.service';
import { DialogService } from '@core/services/dialog.service';
import { ToolPanel } from '@pages/assets-page/components/interfaces';
import { GridApi } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { DvDialogComponent } from '@devinco/ui/dds';

@Injectable({ providedIn: 'root' })
export class AttachmentsService {
  private api = inject(RestApiService);
  private dialog = inject(DialogService);

  getMediaType(fileType: string): string {
    switch (fileType) {
      case 'pdf':
        return 'application/pdf';
      case 'txt':
        return 'text/plain';
      case 'bmp':
        return 'image/bmp';
      default:
        return 'image/jpeg';
    }
  }

  isImage(fileName?: string): boolean {
    if (!fileName) return false;

    const fileNameLowerCase = fileName.toLowerCase();

    return (
      fileNameLowerCase.includes('.jpg') ||
      fileNameLowerCase.includes('.jpeg') ||
      fileNameLowerCase.includes('.svg') ||
      fileNameLowerCase.includes('.png') ||
      fileNameLowerCase.includes('.gif')
    );
  }

  downloadAttachment(attachmentUrl: string): void {
    const a = document.createElement('a');
    a.target = '_parent';
    a.href = attachmentUrl;

    document.documentElement.appendChild(a);
    a.click();
    a.parentNode?.removeChild(a);
  }

  getAttachmentUrl(documentId: number, isPreview = true): Observable<string> {
    return this.api.getCustom(
      `attachment/${documentId}?isPreview=${isPreview}`
    );
  }

  getAttachmentPreview(api: GridApi, entityId: number, fileName: string): void {
    this.getAttachmentUrl(entityId).subscribe(response => {
      const toolPanel = api.getToolPanelInstance('preview') as ToolPanel;
      toolPanel.api.setPath(response as string);
      const assetNameSplit = fileName.split('.');
      const fileType = assetNameSplit[assetNameSplit.length - 1];
      const mediaType = this.getMediaType(fileType);
      toolPanel.api.setMediaType(mediaType);
    });
  }

  openAttachmentDeleteDialog(): DvDialogComponent<undefined, undefined> {
    return this.dialog.open({
      size: 'md',
      type: 'error',
      title: 'General.Dialog.Delete.Title',
      contentText: 'General.Dialog.Delete.Text',
      confirmText: 'General.Confirm',
      cancelText: 'General.Cancel',
    });
  }
}
